/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="8" height="12" viewBox="0 0 8 12" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  
  <polygon points="6.662 11.222 1.414 6 6.683 .705 5.974 0 0 6.003 5.957 11.931" className="icon-fill"/>
</svg>

    );
  }
}

Icon.displayName = 'ChevronLeftIcon';

export default Icon;
